import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { hasPermission, hasCreatePermission } from "../../Utils/PermissionUtils";

function LeftBar() {
  const [logo, setLogo] = useState(`${process.env.PUBLIC_URL}/assets/images/logo_latest.png`);
  const [roleName, setRoleName] = useState("");
  const [permissions, setPermissions] = useState([]);

  // const canLayoutaccess = hasPermission('Layout');

  useEffect(() => {
    const role = localStorage.getItem("roleName");
    setRoleName(role);

    // const permissionData = localStorage.getItem("permission");
    // if (permissionData) {
    //   try {
    //     setPermissions(JSON.parse(permissionData));
    //   } catch (err) {
    //     console.error("Invalid permission data:", err);
    //   }
    // }
  }, []);

  // const hasPermission = (moduleName) => {
  //   if (roleName === "Admin") return true;
  //   return permissions.some(p =>
  //     p.module.trim().toLowerCase() === moduleName.trim().toLowerCase() &&
  //     p.viewModule === true
  //   );
  // };

  // const hasCreatePermission = (moduleName) => {
  //   if (roleName === "Admin") return true;
  //   return permissions.some(p => p.module === moduleName && p.createModule === true);
  // };

  return (
    <div className="sidebar-menu sticky-sidebar-menu">
      {/* <div className="logo"> 
        <h1><a href="/">Collective</a></h1>
      </div> */}
      <div className="logo" style={{ height: 78 + "px" }}>
        <a href="/">
          <img src={logo} alt="Your logo" title="Your logo" className="img-fluid" style={{ maxWidth: 75 + "px" }} />
        </a>
      </div>
      <div className="logo-icon text-center">
        <a href="/" title="logo"><img src={logo} alt="logo-icon" /></a>
      </div>

      <div className="sidebar-menu-inner">
        <ul className="nav nav-pills nav-stacked custom-nav">
          <li className="active">
            <a href="/"><i className="fa fa-tachometer"></i><span> Dashboard</span></a>
          </li>

          <li><Link to="/Calendar"><i className="fa fa-calendar"></i> <span>Calendar</span></Link></li>

          {hasPermission("Layout") && (
            <li>
              <Link to='/LayoutList'><i className="fa fa-object-group"></i> <span> Layouts</span>  </Link>
            </li>
          )}

          {hasPermission("Screen") && (
            <li>
              <Link to='/ScreenList'><i className="fa fa-desktop"></i> <span> Displays</span>  </Link>
            </li>
          )}

          {hasPermission("User") && (
            <li>
              <Link to='/UserList'><i className="fa fa-user"></i> <span> Users</span>  </Link>
            </li>
          )}

          
          

          {/* {hasPermission("Screen") && (
            <li className="menu-list">
              <a href="#"><i className="fa fa-desktop"></i><span>Displays <i className="lnr lnr-chevron-right"></i></span></a>
              <ul className="sub-menu-list">
                <li><Link to='/ScreenList'>Displays List</Link></li>
              </ul>
            </li>
          )} */}

          {/* {hasPermission("User") && (
            <li className="menu-list">
              <a href="#"><i className="fa fa-user"></i><span>Users <i className="lnr lnr-chevron-right"></i></span></a>
              <ul className="sub-menu-list">
                <li><Link to='/UserList'>User List</Link></li>
                {
                  hasCreatePermission("User") && (
                    <li><Link to='/CreateUser'>Create User</Link></li>
                  )
                }
              </ul>
            </li>
          )} */}

          {hasPermission("Campaign") && (
            <li>
              <Link to='/CampaignList'><i className="fa fa-bullhorn"></i> <span> Campaigns</span>  </Link>
            </li>
          )}

          {/* {hasPermission("Campaign") && (
            <li className="menu-list">
              <a href="#"><i className="fa fa-bullhorn"></i><span>Campaign<i className="lnr lnr-chevron-right"></i></span></a>
              <ul className="sub-menu-list">
                <li><Link to='/CreateCampaign'>Create Campaign</Link></li>
                <li><Link to='/CampaignList'>Campaign List</Link></li>
              </ul>
            </li>
          )} */}

          {hasPermission("Schedule") && (
            <li>
              <Link to='/schedule/ScheduleList'><i className="fa fa-calendar-check-o"></i> <span> Schedules</span>  </Link>
            </li>
          )}

          {/* {hasPermission("Schedule") && (
            <li className="menu-list">
              <a href="#"><i className="fa fa-calendar-check-o"></i><span>Schedule Blocks <i className="lnr lnr-chevron-right"></i></span></a>
              <ul className="sub-menu-list">
                <li><Link to='/schedule/ScheduleList'>Schedule List</Link></li>
                {
                  hasCreatePermission("Schedule") && (
                    <li><Link to='/schedule/CreateSchedule'>Add Schedule</Link></li>
                  )
                }
              </ul>
            </li>
          )} */}

          {hasPermission("Content") && (
            <li>
              <Link to='/ContentList'><i className="fa fa-file-text-o"></i> <span> Content</span>  </Link>
            </li>
          )}

          {/* {hasPermission("Content") && (
            <li className="menu-list">
              <a href="#"><i className="fa fa-file-text-o"></i><span>Content <i className="lnr lnr-chevron-right"></i></span></a>
              <ul className="sub-menu-list">
                <li><Link to='/ContentList'>Content List</Link></li>
                {
                  hasCreatePermission("Content") && (
                    <li><Link to='/CreateContent'>Add Content</Link></li>
                  )
                }
              </ul>
            </li>
          )} */}

          {hasPermission("Permission") && (
            <li>
              <Link to='/PermissionList'><i className="fa fa-cogs"></i> <span> Permission</span>  </Link>
            </li>
          )}

          {/* {hasPermission("Permission") && (
            <li className="menu-list">
              <a href="#"><i className="fa fa-cogs"></i><span>Permission <i className="lnr lnr-chevron-right"></i></span></a>
              <ul className="sub-menu-list">
                <li><Link to='/PermissionList'>Permission List</Link></li>
                {
                  hasCreatePermission("Permission") && (
                    <li><Link to='/CreatePermission'>Add Permission</Link></li>
                  )
                }

              </ul>
            </li>
          )} */}

          {hasPermission("Group") && (
            <li className="menu-list">
              <a href="#"><i className="fa fa-users"></i><span>Groups <i className="lnr lnr-chevron-right"></i></span></a>
              <ul className="sub-menu-list">
                <li><Link to="/CreateGroup">Add Group</Link></li>
                {/* <li><Link to="/Groups/3">User Groups </Link></li> */}
                <li><Link to="/Groups/1">Layout Groups</Link></li>
                <li><Link to="/Groups/2">Screen Groups</Link></li>
                <li><Link to="/Groups/3">User Groups</Link></li>
                {/* <li><Link to="/Groups/6">Content Groups</Link></li>
                <li><Link to="/Groups/8">Permission Groups</Link></li> */}
              </ul>
            </li>
          )}


          {roleName === "Admin" && (
            <li className="menu-list">
              <a href="#"><i className="fa fa-users"></i><span>Reports <i className="lnr lnr-chevron-right"></i></span></a>
              <ul className="sub-menu-list">
                <li><Link to="/Report">Proof Of Play</Link></li>

              </ul>
            </li>
          )}
        </ul>

        <a className="toggle-btn">
          <i className="fa fa-angle-double-left menu-collapsed__left"><span>Collapse Sidebar</span></i>
          <i className="fa fa-angle-double-right menu-collapsed__right"></i>
        </a>
      </div>
    </div>
  );
}

export default LeftBar;
